import { Action } from '@ngrx/store';

import { RouterRequestActionType } from './router-request-action-type.enum';

export class RouterRequestRejected implements Action {
  public readonly type: RouterRequestActionType = RouterRequestActionType.RouterRequestRejected;

  constructor(public readonly payload: string) { }
}
